export const GET_REGION_TAG = 'GET_REGION_TAG'
export const GET_REGION_TAG_SUCCESS = 'GET_REGION_TAG_SUCCESS'
export const GET_REGION_TAG_FAILED = 'GET_REGION_TAG_FAILED'

export const GET_REGION_TAGS = 'GET_REGION_TAGS'
export const GET_REGION_TAGS_SUCCESS = 'GET_REGION_TAGS_SUCCESS'
export const GET_REGION_TAGS_FAILED = 'GET_REGION_TAGS_FAILED'

export const CREATE_REGION_TAG = 'CREATE_REGION_TAG'
export const CREATE_REGION_TAG_SUCCESS = 'CREATE_REGION_TAG_SUCCESS'
export const CREATE_REGION_TAG_FAILED = 'CREATE_REGION_TAG_FAILED'

export const UPDATE_REGION_TAG = 'UPDATE_REGION_TAG'
export const UPDATE_REGION_TAG_SUCCESS = 'UPDATE_REGION_TAG_SUCCESS'
export const UPDATE_REGION_TAG_FAILED = 'UPDATE_REGION_TAG_FAILED'

export const DELETE_REGION_TAG = 'DELETE_REGION_TAG'
export const DELETE_REGION_TAG_SUCCESS = 'DELETE_REGION_TAG_SUCCESS'
export const DELETE_REGION_TAG_FAILED = 'DELETE_REGION_TAG_FAILED'
